import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-info-assistance',
  templateUrl: './info-assistance.component.html',
  styleUrls: ['./info-assistance.component.scss']
})
export class InfoAssistanceComponent implements OnInit {
  @ViewChild("infoAssistance", { static: false }) infoAssistance: TemplateRef<any>;

  public closeResult: string;

  constructor(private modalService: NgbModal) { }

  ngOnInit(): void {
  }
  async openModal() {
    this.modalService.open(this.infoAssistance, {
      size: 'lg',
      ariaLabelledBy: 'Cart-Modal',
      centered: true,
      windowClass: 'theme-modal cart-modal CartModal'
    }).result.then((result) => {
      `Result ${result}`
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
}
